import { t } from 'i18n';
import React, { useState } from 'react';
import { styled, Button, Shape } from '@teko/ds-desktop';
import { RefreshOutlined } from '@teko/ds-icon';

export interface BuildPcMobileTabsProps {
  onClickTab?: (tab: number) => void;
  onResetConfig?: () => void;
  lsActiveTab?: number;
}
const Wrapper = styled(Shape)(
  ({ direction }: { direction?: string }) => `
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 0.5rem;
  a {
    text-decoration: unset;
  }
  direction: ${direction};
`,
);
const StyledButton = styled(Button)(
  ({ isActive }: { isActive?: boolean }) => `
    ${!isActive ? 'background-color: #E0E0E0' : ''};
    direction: ltr;
  `,
);

const BuildPcMobileTabs: React.FC<BuildPcMobileTabsProps> = ({
  onClickTab,
  onResetConfig,
  lsActiveTab,
  ...props
}: BuildPcMobileTabsProps) => {
  const [activeTab, setActiveTab] = useState(lsActiveTab || 0);
  return (
    <>
      <Wrapper marginBottom="s8" {...props}>
        {[0, 1, 2].map((tab: number) => (
          <StyledButton
            variant={tab === activeTab ? 'primary' : 'default'}
            isActive={tab === activeTab}
            onClick={(): void => {
              setActiveTab(tab);
              onClickTab && onClickTab(tab);
            }}
            key={tab}
          >
            {t('Cấu hình {{number}}', { number: tab + 1 })}
          </StyledButton>
        ))}
      </Wrapper>
      <Wrapper direction="rtl">
        <StyledButton isActive variant="primary" onClick={onResetConfig}>
          {t('Tạo lại')}
          <RefreshOutlined
            color="white"
            size={16}
            style={{ marginLeft: '0.5rem' }}
          />
        </StyledButton>
      </Wrapper>
    </>
  );
};

export default BuildPcMobileTabs;
